<template>
  <div>
    <v-menu offset-y left>
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-card class="d-flex flex-column px-3 pt-3">
        <vote-log
          :reference="reference"
          :full-text-review="fullTextReview"
        />
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import VoteLog from '@/components/References/VoteLog';
import { Reference } from '@/models';

export default {
  name: 'VoteLogPopup',
  components: { VoteLog },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    fullTextReview: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
